document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-product')) return;
  initSwipeableGallery();
});

function initSwipeableGallery() {
  var grids = document.querySelectorAll('div.slider__grid');

  grids.forEach(function (grid) {
    var slides = Array.from(grid.querySelectorAll('.slider__item'));
    if (slides.length < 2) return;

    var currentIndex = 0;

    // Set initial slide positions
    slides.forEach(function (slide, i) {
      slide.style.position = 'absolute';
      slide.style.top = '0';
      slide.style.left = '0';
      slide.style.width = '100%';
      slide.style.transition = 'transform 0.4s ease';
      slide.style.transform = 'translateX(' + (i * 100) + '%)';
    });

    // Set grid height using aspect ratio from the img-ar div
    function updateHeight() {
      var firstArDiv = slides[0].querySelector('.img-ar');
      if (firstArDiv) {
        var ratio = parseFloat(firstArDiv.style.getPropertyValue('--aspect-ratio'));
        if (ratio) {
          grid.style.height = (grid.offsetWidth / ratio) + 'px';
          return;
        }
      }
      // Fallback: use image natural size
      var img = slides[0].querySelector('img');
      if (img && img.complete && img.naturalHeight) {
        grid.style.height = (grid.offsetWidth * img.naturalHeight / img.naturalWidth) + 'px';
      } else if (img) {
        img.addEventListener('load', function () {
          grid.style.height = (grid.offsetWidth * img.naturalHeight / img.naturalWidth) + 'px';
        });
      }
    }

    // Wait a moment for layout to settle then set height
    setTimeout(updateHeight, 100);
    window.addEventListener('resize', updateHeight);

    // Build prev arrow
    var prevArrow = document.createElement('button');
    prevArrow.className = 'hilweh-arrow hilweh-arrow--prev is-hidden';
    prevArrow.setAttribute('aria-label', 'Previous image');
    prevArrow.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg>';
    grid.appendChild(prevArrow);

    // Build next arrow
    var nextArrow = document.createElement('button');
    nextArrow.className = 'hilweh-arrow hilweh-arrow--next';
    nextArrow.setAttribute('aria-label', 'Next image');
    nextArrow.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"></polyline></svg>';
    grid.appendChild(nextArrow);

    // Build dots
    var dotsContainer = document.createElement('div');
    dotsContainer.className = 'hilweh-dots';

    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'hilweh-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      dot.addEventListener('click', function () {
        goToSlide(i);
      });
      dotsContainer.appendChild(dot);
    });

    grid.parentNode.insertBefore(dotsContainer, grid.nextSibling);

    // Arrow clicks
    prevArrow.addEventListener('click', function () {
      if (currentIndex > 0) goToSlide(currentIndex - 1);
    });
    nextArrow.addEventListener('click', function () {
      if (currentIndex < slides.length - 1) goToSlide(currentIndex + 1);
    });

    function updateArrows() {
      if (currentIndex === 0) {
        prevArrow.classList.add('is-hidden');
      } else {
        prevArrow.classList.remove('is-hidden');
      }
      if (currentIndex === slides.length - 1) {
        nextArrow.classList.add('is-hidden');
      } else {
        nextArrow.classList.remove('is-hidden');
      }
    }

    function goToSlide(index) {
      currentIndex = index;
      slides.forEach(function (slide, i) {
        slide.style.transform = 'translateX(' + ((i - index) * 100) + '%)';
      });
      dotsContainer.querySelectorAll('.hilweh-dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      updateArrows();
      updateHeight();
    }

    // Touch swipe
    var startX = 0;
    var startY = 0;
    var dragging = false;

    grid.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragging = true;
    }, { passive: true });

    grid.addEventListener('touchend', function (e) {
      if (!dragging) return;
      var diffX = startX - e.changedTouches[0].clientX;
      var diffY = startY - e.changedTouches[0].clientY;
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
        if (diffX > 0 && currentIndex < slides.length - 1) goToSlide(currentIndex + 1);
        else if (diffX < 0 && currentIndex > 0) goToSlide(currentIndex - 1);
      }
      dragging = false;
    }, { passive: true });

    // Mouse drag
    grid.addEventListener('mousedown', function (e) {
      startX = e.clientX;
      dragging = true;
    });
    grid.addEventListener('mouseup', function (e) {
      if (!dragging) return;
      var diff = startX - e.clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentIndex < slides.length - 1) goToSlide(currentIndex + 1);
        else if (diff < 0 && currentIndex > 0) goToSlide(currentIndex - 1);
      }
      dragging = false;
    });
    grid.addEventListener('mouseleave', function () {
      dragging = false;
    });
  });
}
// =============================================
// STICKY ADD TO CART BAR - MOBILE ONLY
// =============================================

document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-product')) return;
  initStickyBar();
});

function initStickyBar() {
  // Only run on mobile
  if (window.innerWidth >= 768) return;

  // Find the main Add to Cart button on the page
  var mainBtn = document.querySelector('[name="add"]') ||
                document.querySelector('.product-form__submit') ||
                document.querySelector('[data-add-to-cart]') ||
                document.querySelector('button[type="submit"].btn');

  if (!mainBtn) return;

  // Get product title and price
  var titleEl = document.querySelector('.product-single__title, .product__title, h1.title, h1');
  var priceEl = document.querySelector('.product__price .price, .price__regular, .product-single__price, .price');

  var title = titleEl ? titleEl.innerText.trim() : '';
  var price = priceEl ? priceEl.innerText.trim() : '';

  // Build the sticky bar
  var bar = document.createElement('div');
  bar.className = 'hilweh-sticky-bar';
  bar.innerHTML =
    '<div class="hilweh-sticky-bar__info">' +
      '<p class="hilweh-sticky-bar__title">' + title + '</p>' +
      '<p class="hilweh-sticky-bar__price">' + price + '</p>' +
    '</div>' +
    '<button class="hilweh-sticky-bar__btn" id="hilweh-sticky-btn">Add to Cart</button>';

  document.body.appendChild(bar);

  var stickyBtn = document.getElementById('hilweh-sticky-btn');

  // Show bar when user scrolls past the main button
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    });
  }, { threshold: 0 });

  observer.observe(mainBtn);

  // Clicking sticky button triggers the real Add to Cart button
  stickyBtn.addEventListener('click', function () {
    stickyBtn.disabled = true;
    stickyBtn.textContent = 'Adding...';

    // Trigger the actual form submit
    var form = document.querySelector('[action="/cart/add"]') ||
               document.querySelector('form.product-form') ||
               document.querySelector('form[data-product-form]');

    if (form) {
      var submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      form.dispatchEvent(submitEvent);

      // Also click the real button as fallback
      mainBtn.click();
    } else {
      mainBtn.click();
    }

    // Re-enable after short delay
    setTimeout(function () {
      stickyBtn.disabled = false;
      stickyBtn.textContent = 'Add to Cart';
    }, 2000);
  });
}